/**
 * useAudioProgress — reactive Audio Lessons playback progress.
 *
 * Subscribes to the `audioPlayer` service's progress store (a JS-ticker source
 * over `player.currentTime`), so the player transport + the karaoke
 * `SyncedTranscript` re-render only when position/duration/playing actually
 * change. Decoupled from the engine: the underlying player instance can be
 * replaced (teaching-language swap) without the hook re-subscribing.
 */

import { useSyncExternalStore } from 'react';
import {
  subscribeProgress,
  getProgressSnapshot,
  type AudioProgressSnapshot,
} from '../services/audioPlayer';

export function useAudioProgress(): AudioProgressSnapshot {
  return useSyncExternalStore(subscribeProgress, getProgressSnapshot, getProgressSnapshot);
}
